import script from "./PlanGuardBindings.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanGuardBindings.vue?vue&type=script&setup=true&lang=js"

import "./PlanGuardBindings.vue?vue&type=style&index=0&id=88365ddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88365ddc"]])

export default __exports__